import styled from 'styled-components'

export const StyledSubheader = styled.span`
  font-size: 20px;
  font-weight: 400;
  margin-bottom: 8px;
`
